/*
 * What a Leaflet tooltip or popup shows. Leaflet sets a STRING as innerHTML,
 * so a mission title typed as `<img src=x onerror=…>` would run in the
 * browser of everyone who opens the map -- and could read the sign-in token
 * kept in localStorage. Every bindTooltip/bindPopup in the app goes through
 * here instead: a <span> whose text is set as text, never parsed as markup.
 * Pinned by leafletText.rules.test.js.
 */
export function tooltipText(value) {
  const span = document.createElement('span');
  span.textContent = value == null ? '' : String(value);
  return span;
}
